// Binary representations of data sizes
export const KB = Math.pow(2, 10) // 1 Kilobyte = 1024 bytes
export const MB = Math.pow(2, 20) // 1 Megabyte = 1,048,576 bytes
